import { Alert, Box, Typography } from '@mui/material'
import { ReactNode, useEffect } from 'react'

import StockDeductionCards from './StockDeductionCards'
import StockDeductionDailyTable from './StockDeductionDailyTable'
import { IStockReportFilter } from './types'
import { useStockReport } from './useStockReport'

interface Props {
  platform: string
  // ช่วงวันที่ผู้ใช้กดค้นหาแล้ว (ไม่ใช่ค่าที่กำลังพิมพ์) — ใช้ตัวเดียวกับแท็บอื่นในหน้า
  filter: IStockReportFilter
  detailUrl: string // + /:date
  // ส่วนเสริมเฉพาะ platform (เช่น ปุ่มตัดสต๊อกย้อนหลังของ TikTok) — โชว์เหนือการ์ด
  extra?: ReactNode
  // เปลี่ยนค่า → โหลดรายงานใหม่ (หลังตัดย้อนหลังเสร็จ)
  reloadKey?: number
}

// แท็บรายงานการตัดสต๊อกในหน้ารายงานยอดขายของแต่ละ marketplace
// กดวันที่ในตาราง → เปิดแท็บใหม่ดูรายละเอียดของวันนั้น (สินค้า + รายการที่ตัดไม่ได้)
const StockDeductionTab = ({
  platform,
  filter,
  detailUrl,
  extra,
  reloadKey,
}: Props) => {
  const { data, isLoading, error, mutate } = useStockReport({
    platform,
    startDate: filter.startDate,
    endDate: filter.endDate,
    shopId: filter.shopId,
  })

  useEffect(() => {
    if (reloadKey) {
      mutate()
    }
  }, [reloadKey, mutate])

  const openDetail = (date: string) => {
    const params = new URLSearchParams({ platform })
    if (filter.shopId) {
      params.set('shopId', filter.shopId)
    }
    window.open(
      `${detailUrl}/${date}?${params.toString()}`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  if (error) {
    return (
      <Alert severity="error">
        โหลดรายงานไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
      </Alert>
    )
  }

  return (
    <Box>
      {extra}

      <StockDeductionCards summary={data?.summary} />

      {!!data?.summary?.failureQuantity && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          สต๊อกของสินค้าที่ขายไปแล้ว {data.summary.failureQuantity} ชิ้น
          ยังไม่ถูกตัด เพราะตอนขายหาสินค้าในระบบไม่เจอ —
          กดวันที่ในตารางเพื่อดูว่าเป็น SKU ไหน แล้วผูกสินค้าที่หน้ารายการสินค้า
          {extra ? ' จากนั้นกด "ตัดสต๊อกย้อนหลัง"' : ''}
        </Alert>
      )}

      <Typography variant="subtitle1" mb={1}>
        รายวัน
      </Typography>
      <StockDeductionDailyTable
        data={data?.daily ?? []}
        isLoading={isLoading}
        onSelectDate={openDetail}
      />
    </Box>
  )
}

export default StockDeductionTab
